<template>
  <ion-page v-if="sharedState.ui" :key="sharedState.language">
    <ion-tabs>
      
      <AppHeader slot="top" />
      <ion-router-outlet></ion-router-outlet>
      
      <ion-tab-bar slot="bottom" dir="ltr">  
        <ion-tab-button tab="tab1" href="/home">
          <ion-icon :icon="home" aria-hidden="true" />
          <ion-label :aria-label="sharedState.ui.tabs.home" v-html="sharedState.ui.tabs.home" role="navigation"></ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="tab2" href="/resources">
          <ion-icon :icon="folder" aria-hidden="true" />
          <ion-label :aria-label="sharedState.ui.tabs.resources" v-html="sharedState.ui.tabs.resources" role="navigation"></ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="tab3" href="/bookmarks">
          <ion-icon :icon="bookmark" aria-hidden="true" />
          <ion-label :aria-label="sharedState.ui.tabs.bookmark" v-html="sharedState.ui.tabs.bookmark" role="navigation"></ion-label>
        </ion-tab-button>
        
        <ion-tab-button v-if="sharedState.deviceType === 'ios' || sharedState.deviceType === 'android'" tab="tab4" href="/calendar">
          <ion-icon :icon="calendar" aria-hidden="true" />
          <ion-label :aria-label="sharedState.ui.tabs.calendar" v-html="sharedState.ui.tabs.calendar" role="navigation"></ion-label>
        </ion-tab-button>
        
        <ion-tab-button tab="tab5" href="/settings">
          <ion-icon :icon="settings" aria-hidden="true" />
          <ion-label :aria-label="sharedState.ui.tabs.settings" v-html="sharedState.ui.tabs.settings" role="navigation"></ion-label>
        </ion-tab-button>
      </ion-tab-bar>

    </ion-tabs>
  </ion-page>
</template>

<script>
import { IonRouterOutlet, IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage } from '@ionic/vue';
import { home, folder, bookmark, settings, calendar } from 'ionicons/icons';
import AppHeader from '@/components/AppHeader.vue';
import { store } from '@/store';

export default {
  name: 'Tabs',
  components: { AppHeader, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage },
  setup() {
    return {
      home,
      folder,
      bookmark,
      settings,
      calendar
    }
  },
  data() {
    return {
      sharedState: store.state,
    }
  },
  async mounted() {
    const lang = await store.getLanguage();
    const dir = (lang == 'ar' || lang == 'fa') ? 'rtl' : 'ltr';
    this.$el.querySelector('ion-router-outlet').setAttribute('dir', dir);
  }
}
</script>

<style scoped>
  ion-tab-bar { 
    min-height: 70px; 
    padding-bottom: var(--ion-safe-area-bottom);
  }

  ion-tab-button { width: 20%; }

  ion-tab-button::part(native) { padding: 0 0.125em; }

  ion-label { font-size: 0.625rem !important; }
</style>